import React, { useState } from "react";
import { Container } from "reactstrap";
import { Bell } from "assets";
import CustomButton from "components/CustomButton";
import useLoginStore from "hooks/useLoginStore";
import { API_POST_MAMBOO } from "services";
import Swal from "sweetalert2";
import "./draftKontrak.scss";

/**
 * Halaman draft kontrak untuk user yang belum punya `mamboo_id`.
 *
 * Selama mamboo_id belum terbit, hanya halaman ini yang bisa diakses
 * (lihat `components/ProfileCompletionGate.js` dan `pages/sidebar/index.js`).
 */

// TODO: masih dummy. Ganti dengan draft kontrak asli, atau URL dari API kalau
// dokumennya nanti dibuat per anggota.
const DRAFT_KONTRAK_URL = `${process.env.PUBLIC_URL}/draft-kontrak-dummy.pdf`;

const DraftKontrak = () => {
  const [isSending, setIsSending] = useState(false);
  const serverProfile = useLoginStore((state) => state.serverProfile);
  const fetchServerProfile = useLoginStore((state) => state.fetchServerProfile);

  // Backend hanya menerima sekali kirim; tombol ikut dikunci supaya user tidak
  // menekan berulang lalu ditolak.
  const hasSentInterest = Boolean(serverProfile?.join_interest_at);

  const handleBergabung = () => {
    Swal.fire({
      icon: "question",
      title: "Bergabung Sebagai Anggota",
      text: "Apakah kamu setuju dengan draft kontrak di atas?",
      showCancelButton: true,
      cancelButtonText: "Nanti",
      showConfirmButton: true,
      confirmButtonText: "Ya, Saya Tertarik",
      confirmButtonColor: "#4dbd74",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      setIsSending(true);
      try {
        await API_POST_MAMBOO.actions.joinInterest();
        // Ambil ulang profil supaya penanda sekali-kirim langsung terbaca.
        await fetchServerProfile();
        Swal.fire(
          "Terima kasih!",
          "Minat kamu sudah diteruskan ke admin. Tim kami akan segera menghubungi kamu.",
          "success"
        );
      } catch (err) {
        const message =
          err?.response?.data?.data ||
          "Gagal mengirim pemberitahuan. Silakan coba lagi.";
        Swal.fire("Gagal", message, "error");
      } finally {
        setIsSending(false);
      }
    });
  };

  return (
    <Container fluid className="content-pencipta">
      <div className="header-content">
        <div className="pencipta-header">
          <h1>Draft Kontrak</h1>
          <span>
            Baca draft kontrak berikut sebelum bergabung menjadi anggota
          </span>
        </div>
        <div className="icon-wrapper">
          <Bell />
        </div>
      </div>

      <div className="draft-kontrak-frame">
        <object
          className="draft-kontrak-viewer"
          data={DRAFT_KONTRAK_URL}
          type="application/pdf"
          aria-label="Draft kontrak kerja sama"
        >
          {/* Sebagian browser — terutama di perangkat mobile — tidak bisa
              menampilkan PDF inline, jadi sediakan jalan keluarnya. */}
          <div className="draft-kontrak-fallback">
            <p className="fallback-text">
              Preview dokumen tidak dapat ditampilkan di browser ini.
            </p>
            <a href={DRAFT_KONTRAK_URL} target="_blank" rel="noreferrer">
              Buka draft kontrak di tab baru
            </a>
          </div>
        </object>
      </div>

      <div className="draft-kontrak-action">
        <CustomButton
          label={
            hasSentInterest
              ? "Menunggu Konfirmasi Admin"
              : isSending
              ? "Mengirim..."
              : "Tertarik, Untuk Bergabung!"
          }
          color={isSending || hasSentInterest ? "secondary-btn" : "primary-btn"}
          onClick={handleBergabung}
          disabled={isSending || hasSentInterest}
        />
      </div>
    </Container>
  );
};

export default DraftKontrak;
